import { useTranslation } from 'react-i18next';
import { currentLanguage, type Lang } from '.';

// Текущий язык внутри React. Смысл в подписке: useTranslation перерисовывает
// компонент на changeLanguage, поэтому всё, что зависит от языка не через t()
// (формат даты, локаль календаря, подсветка в свитчере), обязано брать язык
// отсюда, а не вызывать currentLanguage() напрямую — иначе останется на старом
// языке до следующего рендера по другой причине.
export function useLanguage(): Lang {
  useTranslation();
  return currentLanguage();
}
